import React, { useState } from "react";
import Beatloader from "../../../Common/Loaders/Beatloader";
import { Table } from "antd";

const columns = [
  {
    title: "TDS Category",
    dataIndex: "tds_category",
    key: "tds_category",
    render: (text) => (
      <span className="badge bg-light text-primary px-3 py-2 rounded-pill">
        {text}
      </span>
    ),
  },
  {
    title: "Vendor Name",
    dataIndex: "vendor_name",
    key: "vendor_name",
  },
  {
    title: "PAN Number",
    dataIndex: "pan",
    key: "pan",
  },
  {
    title: "Payment Amount",
    dataIndex: "payment_amount",
    key: "payment_amount",
  },
  {
    title: "TDS Rate (%)",
    dataIndex: "tds_rate",
    key: "tds_rate",
  },
  {
    title: "TDS Deducted",
    dataIndex: "tds_deducted",
    key: "tds_deducted",
  },
  {
    title: "TDS Payable",
    dataIndex: "tds_payable",
    key: "tds_payable",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: () => (
      <span className="badge bg-warning-subtle text-warning rounded-pill px-3 py-2">
        Pending
      </span>
    ),
  },
];

const TdsManagement = () => {
  const [purchaseInvoiceSearch, setPurchaseInvoiceSearch] = useState({
    from_date: "",
    to_date: "",
    tdc_category: "",
    vendor_type: "",
    branch: "",

    // ted update
    auto_create_journal_entries: false,
    manual_review_first: false,

    update_method: "",
    tds_payable_amount: "",
    update_date: "",
    update_narration: "",
    generate_journal_entries: false,
  });

  const [pageLoader, setPageLoader] = useState(false);

  const [dataSourcer, setDataSourcer] = useState([
    {
      key: 1,
      tds_category: "194C",
      vendor_name: "Transport Services Ltd",
      pan: "ABCDE1234F",
      payment_amount: "₹ 5,00,000",
      tds_rate: "1.00%",
      tds_deducted: "₹ 5,000",
      tds_payable: "₹ 5,000",
      status: "Pending",
    },
    {
      key: 2,
      tds_category: "194J",
      vendor_name: "Professional Consultants",
      pan: "FGHIJ5678K",
      payment_amount: "₹ 3,00,000",
      tds_rate: "10.00%",
      tds_deducted: "₹ 30,000",
      tds_payable: "₹ 30,000",
      status: "Pending",
    },
    {
      key: 3,
      tds_category: "194I",
      vendor_name: "Property Management Co",
      pan: "KLMNO9012P",
      payment_amount: "₹ 1,50,000",
      tds_rate: "10.00%",
      tds_deducted: "₹ 15,000",
      tds_payable: "₹ 15,000",
      status: "Pending",
    },
    {
      key: 4,
      tds_category: "194H",
      vendor_name: "Commission Agents Pvt Ltd",
      pan: "PQRST3456U",
      payment_amount: "₹ 2,00,000",
      tds_rate: "5.00%",
      tds_deducted: "₹ 10,000",
      tds_payable: "₹ 10,000",
      status: "Pending",
    },
  ]);

  const onValueChange = (e) => {
    const { name, type, value, checked } = e.target;

    setPurchaseInvoiceSearch((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  return (
    <>
      {pageLoader ? (
        <Beatloader />
      ) : (
        <div className="page-wrapper">
          <div className="content">
            <style>
              {`
          .padding-pt-9 {
            padding: 10px;
          }
        `}
            </style>

            <div className="card p-4">
              <h5 className="fw-semibold mb-3">Purchase Invoice Search</h5>
              <div className="row">
                {/* from_date */}
                <div className="col-12 col-sm-4 col-md-3 mb-4">
                  <label className="form-label fw-medium">From Date</label>
                  <input
                    type="date"
                    name="from_date"
                    className="form-control bg-light"
                    placeholder="Enter from date"
                    onChange={onValueChange}
                    value={purchaseInvoiceSearch.from_date}
                  />
                </div>

                {/* to_date */}
                <div className="col-12 col-sm-4 col-md-3 mb-4">
                  <label className="form-label fw-medium">To Date</label>
                  <input
                    type="date"
                    name="to_date"
                    className="form-control bg-light"
                    placeholder="Enter to date"
                    onChange={onValueChange}
                    value={purchaseInvoiceSearch.to_date}
                  />
                </div>

                {/* tdc_category */}
                <div className="col-12 col-sm-4 col-md-3 mb-4">
                  <label className="form-label fw-medium">TDS Category </label>
                  <select
                    name="tdc_category"
                    className="form-select bg-light padding-pt-9"
                    value={purchaseInvoiceSearch.tdc_category}
                    onChange={onValueChange}
                  >
                    <option value="">Select tdc category </option>
                    <option value="tdc_category">tdc_category 1</option>
                  </select>
                </div>

                {/* vendor_type */}
                <div className="col-12 col-sm-4 col-md-3 mb-4">
                  <label className="form-label fw-medium">Vendor Type</label>
                  <select
                    name="vendor_type"
                    className="form-select bg-light padding-pt-9"
                    value={purchaseInvoiceSearch.vendor_type}
                    onChange={onValueChange}
                  >
                    <option value="">Select vendor_type </option>
                    <option value="vendor_type">vendor_type 1</option>
                  </select>
                </div>

                {/* branch */}
                <div className="col-12 col-sm-4 col-md-3 mb-4">
                  <label className="form-label fw-medium">Branch </label>
                  <select
                    name="branch"
                    className="form-select bg-light padding-pt-9"
                    value={purchaseInvoiceSearch.branch}
                    onChange={onValueChange}
                  >
                    <option value="">Select branch </option>
                    <option value="branch">branch 1</option>
                  </select>
                </div>

                {/* ACTION BUTTONS */}
                <div className="d-flex flex-wrap gap-2 mt-3">
                  <button className="btn btn-primary px-4">
                    <i className="fas fa-search me-1"></i> Calculate
                  </button>

                  <button className="btn btn-light border px-4">
                    <i className="fas fa-undo me-1"></i> Clear
                  </button>
                </div>
              </div>
            </div>

            {/* card */}
            <div className="row g-3">
              <div className="col-12 col-md-4 col-sm-6">
                <div className="card p-3 rounded-4 shadow-sm text-center">
                  <p className="text-muted mb-1">Total Payment Amount</p>
                  <h3 className="fw-semibold">34234</h3>
                </div>
              </div>

              <div className="col-12 col-md-4 col-sm-6">
                <div className="card p-3 rounded-4 shadow-sm text-center">
                  <p className="text-muted mb-1">Total TDS Payable</p>
                  <h3 className="fw-semibold">34234</h3>
                </div>
              </div>

              <div className="col-12 col-md-4 col-sm-6">
                <div className="card p-3 rounded-4 shadow-sm text-center">
                  <p className="text-muted mb-1">Number Of Vendors</p>
                  <h3 className="fw-semibold">34234</h3>
                </div>
              </div>
            </div>

            {/* table */}
            <div className="card p-4">
              <h5 className="fw-semibold mb-3">TDS Calculation Details</h5>

              <div className="table-responsive custom-table query-list-table mt-4">
                <Table
                  className="table datanew dataTable no-footer"
                  // rowSelection={rowSelection}
                  dataSource={dataSourcer}
                  columns={columns}
                  pagination={false}
                  rowClassName={(record) =>
                    record.is_priority === "YES" ? "prior-query" : ""
                  }
                />
              </div>
            </div>

            {/* TDS Update */}
            <div className="card p-4">
              <h5 className="fw-semibold mb-3">Update TDS Payable </h5>

              <div className="row">
                {/* update_method */}
                <div className="col-12 col-md-6 mb-4">
                  <label className="form-label fw-medium d-block">
                    Update Method
                  </label>

                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="update_method"
                      id="auto"
                      value="auto"
                      checked={purchaseInvoiceSearch.update_method === "auto"}
                      onChange={onValueChange}
                    />
                    <label className="form-check-label" htmlFor="auto">
                      Auto - Create Journal Entries
                    </label>
                  </div>

                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="update_method"
                      id="manual"
                      value="manual"
                      checked={purchaseInvoiceSearch.update_method === "manual"}
                      onChange={onValueChange}
                    />
                    <label className="form-check-label" htmlFor="manual">
                      Manual - Review First
                    </label>
                  </div>
                </div>

                {/* tds_payable_amount */}
                <div className="col-12 col-md-6 mb-4">
                  <label className="form-label fw-medium">
                    TDS Payable Amount
                  </label>
                  <select
                    name="tds_payable_amount"
                    className="form-select bg-light padding-pt-9"
                    value={purchaseInvoiceSearch.tds_payable_amount}
                    onChange={onValueChange}
                  >
                    <option value="">Select tds_payable_amount </option>
                    <option value="tds_payable_amount">
                      tds_payable_amount 1
                    </option>
                  </select>
                </div>

                {/* update_date */}
                <div className="col-12 col-md-6 mb-4">
                  <label className="form-label fw-medium">Update Date</label>
                  <input
                    type="date"
                    name="update_date"
                    className="form-control bg-light"
                    placeholder="Enter date"
                    onChange={onValueChange}
                    value={purchaseInvoiceSearch.update_date}
                  />
                </div>

                {/* update_narration */}
                <div className="col-12 col-md-6 mb-4">
                  <label className="form-label fw-medium">
                    Update Narration
                  </label>
                  <input
                    type="text"
                    name="update_narration"
                    className="form-control bg-light"
                    value={purchaseInvoiceSearch.update_narration}
                    onChange={onValueChange}
                    placeholder="update narration "
                  />
                </div>

                {/* generate_journal_entries */}
                <div className="col-12 mb-4">
                  <div className="d-flex align-items-center gap-2 mt-1">
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        defaultChecked
                        name="generate_journal_entries"
                        checked={purchaseInvoiceSearch.generate_journal_entries}
                        onChange={onValueChange}
                      />
                    </div>
                    <span>Generate Journal Entries Automatically</span>
                  </div>
                </div>

                <div className="card p-2">
                  <h6 className="fw-semibold mb-3">Preview Journal Entry</h6>

                  <div className="d-flex justify-content-between">
                    <h6 className="text-gray">Debit: Expense Accounts</h6>
                    <h6 className="">₹ 34343</h6>
                  </div>
                  <div className="d-flex justify-content-between">
                    <h6 className="text-gray">Credit: TDS Payable Account</h6>
                    <h6>₹ 3434</h6>
                  </div>
                  <div className="d-flex justify-content-between">
                    <h6 className="text-gray">Total:</h6>
                    <h6>₹ 3434</h6>
                  </div>
                </div>

                {/* ACTION BUTTONS */}
                <div className="d-flex flex-wrap gap-2 mt-3">
                  <button className="btn btn-primary px-4">
                    <i className="fas fa-save me-1"></i> Update
                  </button>

                  <button className="btn btn-light border px-4">
                    Generate Entries
                  </button>
                  <button className="btn btn-light border px-4">
                    <i className="fas fa-Preview me-1"></i> Export
                  </button>

                  <button className="btn btn-light border px-4">
                    Print Report
                  </button>
                  <button className="btn btn-light border px-4">
                    <i class="fa-solid fa-undo"></i> Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TdsManagement;
